<template>
	<div id="app" class="app_container">
		<!-- 导航 -->
		<div 
			v-if="isHideForTest && !isNavHiddenForCurrentRoute" 
			class="nav_container" 
			:class="isNavBgColorful ? 'nav_container_spl' : ''">
			<!-- :style="{ backgroundColor: isNavBgColorful ? topBannerNavBgColorful : topBannerNavBgTransparent }" -->
			<nav>
				<!-- 左侧LOGO -->
				<div class="nav_left">
					<img :src="isNavBgColorful ? logoFileBShow : logoFileWShow" alt="logo" @click="goHome()" />
				</div>
				
				<!-- 中间菜单栏 -->
				<div class="nav_right" v-if="!isM">
					<el-menu 
						class="el-menu-demo" 
						mode="horizontal" 
						menu-trigger="hover" 
						:default-active="activeIndex" 
						@select="handleSelect" 
						@mouseenter.native="setLink2Hover(true)" 
						@mouseleave.native="setLink2Hover(false)"><!-- :router="true"  -->
						<el-submenu 
							index="null" 
							popper-class="submenu-zdy" 
							:show-timeout="showTimeout" 
							:hide-timeout="hideTimeout"><!-- index="/demo-app"  -->
							<template slot="title">{{ $t('index.nav.nav_title_1') }}</template>
							<el-menu-item 
								@mouseenter.native="setLink2Hover(true)" 
								@mouseleave.native="setLink2Hover(false)">
								<div class="open-area">
									<div class="area-left">
										<div 
											class="area-left-item" 
											v-for="(item, index) in openMenu" :key="item.tit" 
											v-if="index > 0" 
											@mouseenter="showGameFromTypeRight(index)">
											<div><img :src="item.img" alt=""></div>
											<div :class="{ active: currentOpenMenuIndex === index }">{{ item.tit }}</div>
										</div>
									</div>

									<div class="area-right">
										<div 
											class="right-content right-content-0" 
											v-for="i in openMenu.length" :key="i" 
											v-if="(i-1) === currentOpenMenuIndex">
											<div class="img-box">
												<div 
													class="img-block" 
													v-for="(jItem, idx) in allGamesRight" :key="currentOpenMenuIndex + '-' + idx + '-' + jItem.game_id" 
													@click="gotoGameDetail(jItem.game_id)">
													<img :src="jItem.icon" alt="" />
													<div v-if="false">{{ jItem.game_name }}</div>
												</div>
											</div>

											<div class="btn-box">
												<button @click="gotoAllGames">
													{{ $t('index.btn_all_games') }} <img src="@/assets/static/imgs/common/arrow-white.png" alt="">
												</button>
											</div>
										</div>
									</div>
								</div>
							</el-menu-item>
						</el-submenu>

						<el-menu-item 
							@click="gotoTarget('#apply_sence')">
							{{ $t('index.nav.nav_title_2') }}
						</el-menu-item>

						<el-menu-item 
							@click="openDemoDialog(true)">
							{{ $t('index.nav.nav_title_3') }}
						</el-menu-item>

						<el-menu-item 
							@click="gotoTarget('#products_services')">
							{{ $t('index.nav.nav_title_4') }}
						</el-menu-item>

						<el-menu-item 
							@click="gotoTarget('#business_cooperation')">
							{{ $t('index.nav.nav_title_5') }}
						</el-menu-item>
					</el-menu>
				</div>

				<div class="m-menu-right-box" v-if="isM">
					<div class="m-menu-right-menu">
						<img :src="isNavBgColorful ? staticResources.mobileMenuImgOn : staticResources.mobileMenuImgOff" alt="menu" @click="openMobileMenu(true)" />
					</div>
				</div>

				<!-- 右侧语言切换 -->
				<div class="nav_right_lang" v-if="false">
					<span :class="{ active: $i18n.locale === 'en' }" @click="handleLangClick('en')">EN</span>
					<span> | </span>
					<span :class="{ active: $i18n.locale === 'cn' }" @click="handleLangClick('cn')">中</span>
				</div>
			</nav>
		</div>

		<!-- 主路由出口：路由匹配到的组件将渲染在这里 -->
		<router-view v-if="isDataReady" />

		<!-- 移动端菜单 -->
		<RightMenuContent v-if="isShowMobileMenu" />
	</div>
</template>

<script>
import logoFileB        from '@/assets/static/imgs/common/logo-b.png';
import logoFileW        from '@/assets/static/imgs/common/logo-w.png';
import logoFileBM       from '@/assets/static/imgs/common/m/logo-b-m.png';
import logoFileWM       from '@/assets/static/imgs/common/m/logo-w-m.png';
import mobileMenuImgOn  from '@/assets/static/imgs/common/m/btn-menu-m-on.png';
import mobileMenuImgOff from '@/assets/static/imgs/common/m/btn-menu-m-off.png';
import RightMenuContent from '@/components/mobile/RightMenuContent.vue';
import { mapState }     from 'vuex';
import {
	MOBILE_MENU_FLAG,
	NAV_IS_PAGE_SCROLL,
	DEMO_DIALOG_IS_SHOW,
	FORM_DIALOG_IS_SHOW
} from '@/type/mutation';
import { goToHome }            from '@/utils/routerUtils';
import { setLang }             from '@/api/common/setLanguage';
import { fetchAllGamesCached } from '@/api/gameDataLoader';

export default {
	components: {
		RightMenuContent
	},
	data() {
		return {
			staticResources: {
				logoFileB,
				logoFileW,
				logoFileBM,
				logoFileWM,
				mobileMenuImgOn,
				mobileMenuImgOff
			},
			activeIndex              : '1',
			topBannerNavBgTransparent: 'transparent',// 顶部导航栏背景色：默认透明
			topBannerNavBgColorful   : 'rgba(255, 255, 255, 1)',
			showTimeout              : 0,
			hideTimeout              : 0,
			currentOpenMenuIndex     : 1,
			openMenu: [
				{
					img: require('@/assets/static/imgs/common/icon_Global.png'),
					tit: this.$t('index.sub_nav.tit_0')
				},
				{
					img: require('@/assets/static/imgs/common/icon_Global.png'),
					tit: this.$t('index.sub_nav.tit_1')
				},
				{
					img: require('@/assets/static/imgs/common/icon_MiddleEast.png'),
					tit: this.$t('index.sub_nav.tit_2')
				},
				{
					img: require('@/assets/static/imgs/common/icon_America.png'),
					tit: this.$t('index.sub_nav.tit_3')
				},
				{
					img: require('@/assets/static/imgs/common/icon_SoutheastAsia.png'),
					tit: this.$t('index.sub_nav.tit_4')
				}
			],
			isDataReady  : false,// 标记数据是否准备好
			allGamesRight: [],
			allGames     : []
		}
	},

	async mounted() {
		try {
			const data       = await fetchAllGamesCached();
			this.allGames    = data;
			this.isDataReady = true;

			// 初始化右侧菜单
			this.showGameFromTypeRight(this.currentOpenMenuIndex || 1);
		}
		catch(err) {
			console.error('=== App__mounted__load__failed >>>', err);
		}
	},

	methods: {
		// 切换
		handleSelect(key, keyPath)
		{
			// console.log('=== key >>>', key, keyPath);
		},

		// 切换语言
		handleLangClick(langType)
		{
			// console.log('=== App__handleLangClick__langType >>>', langType);
			this.$i18n.locale = langType;
			setLang(langType);
		},

		// 鼠标移入、移出顶部导航
		setLink2Hover(value)
		{
			// 如果鼠标在导航上移出
			if(!value)
			{
				// 如果滚动距离大于0，则导航栏保持原样
				let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				if(scrollTop) { return; }

				// 如果当前页面是 game_detail
				if(this.$route.name == 'gamedetail') { return; }
			}

			// console.log('=== App__setLink2Hover__isNavBgColorful__0 >>>', this.isNavBgColorful);
			// console.log('=== App__setLink2Hover__value >>>', value);
			this.$store.commit(NAV_IS_PAGE_SCROLL, value);
			// console.log('=== App__setLink2Hover__isNavBgColorful__1 >>>', this.isNavBgColorful);

			// 重置导航子菜单默认显示项
			this.showGameFromTypeRight(1);
		},

		// 顶部导航菜单展开后：左侧子菜单鼠标移入事件
		showGameFromTypeRight(index)
		{
			// 1) 调试信息：打印入参与类型
			// console.log('=== App__showGameFromTypeRight__index >>>', index, 'type >>>', typeof index);

			// 2) 防护：确保 allGames 是数组
			if(!Array.isArray(this.allGames) || this.allGames.length === 0)
			{
				console.warn('=== App__showGameFromTypeRight__allGames is empty or not an array >>>', this.allGames);
				return;
			}

			// 3) 规范化 index（把 "1" 之类的字符串变为数值），避免类型不匹配导致 filter 为空
			const idx = Number(index);
			if(Number.isNaN(idx))
			{
				console.warn('=== App__showGameFromTypeRight__index cannot be converted to Number, using original index >>>', index);
			}

			this.currentOpenMenuIndex = idx;

			// 4) 先打印 sample，方便定位 game.category 的类型和值
			// console.log('=== App__showGameFromTypeRight__sample games infos >>>', this.allGames.slice(0, 8).map(g => ({ id: g.game_id, category: g.category, catType: typeof g.category })));

			// 5) 按类别过滤，过滤时使用 Number() 强制比较，避免 "1" === 1 的问题
			this.allGamesRight = this.allGames.filter(game => Number(game.category) === idx);

			// 6) 兼容降级：如果上面没命中（长度为0），再尝试宽松比较（避免非标准格式）
			if(this.allGamesRight.length === 0)
			{
				console.warn('=== App__showGameFromTypeRight__strict filter returned empty, try loose equality fallback <<<');
				this.allGamesRight = this.allGames.filter(game => game.category == index);
			}
			// console.log('=== App__showGameFromTypeRight__this.allGamesRight__by__category >>>', this.allGamesRight);

			// 7) 排序
			switch(idx) {
				case 1:
				case 2:
				case 3:
				case 4:
					this.allGamesRight.sort((a, b) => Number(b.game_id) - Number(a.game_id));
					break;
				default:
					break;
			}
			// console.log('=== App__showGameFromTypeRight__this.allGamesRight__by__sort >>>', this.allGamesRight);

			// 8) 截取前 7 个
			this.allGamesRight = this.allGamesRight.slice(0, 7);
			// console.log('=== App__showGameFromTypeRight__this.allGamesRight__by__slice >>>', this.allGamesRight);
		},

		// 跳转至首页
		goHome()
		{
			// console.log('=== App top logo click <<<');
			goToHome(this.$router);
		},

		// 跳转至全部游戏页
		gotoAllGames()
		{
			this.$router.push('/allgames');
		},

		// 跳转至游戏详情页
		gotoGameDetail(currentGameId)
		{
			// console.log('=== App__gotoGameDetail__currentGameId >>>', currentGameId);
			let _sign = this.$Common.makeSign(this, currentGameId);
			let _path = this.$Common.toSprintf('/gamedetail/%s/%s', currentGameId, _sign);
			this.$router.push({
				// path: `/gamedetail/${currentGameId}/${sign}`
				path: _path
			});
		},

		// 跳转到指定锚点
		gotoTarget(target)
		{
			if
			(
				(
					this.$route.name == 'allgames' && 
					(target == '#products_services' || target == '#apply_sence')
				)
				|| 
				(
					this.$route.name == 'gamedetail' && 
					(target == '#products_services' || target == '#apply_sence' || target == '#business_cooperation')
				)
			)
			{
				this.goHome();
			}
			else
			{
				document.querySelector(target).scrollIntoView({
					behavior: 'smooth'
				});
			}
		},

		// 弹出DEMO弹窗
		openDemoDialog(value)
		{
			// console.log('=== App__openDemoDialog <<<');
			this.$store.commit(DEMO_DIALOG_IS_SHOW, value);
		},

		// 打开移动端菜单
		openMobileMenu(value)
		{
			// console.log('=== App__openMobileMenu <<<');
			this.$store.commit(MOBILE_MENU_FLAG, value);
		}
	},

	computed: {
		// ES6展开合并运算符
		...mapState(['isNavBgColorful', 'isShowMobileMenu', 'isHideForTest']), 

		/**
		 * 判断：是否移动端设备
		 * true-移动端, false-PC端
		 */
		isM()
		{
			return this.$Common.isMobile();
		},

		/**
		 * 当前路由是否隐藏顶部导航
		 */
		isNavHiddenForCurrentRoute()
		{
			return ['sa', 'pp'].includes(this.$route.name);
		},

		// 黑
		logoFileBShow()
		{
			return this.isM ? this.staticResources.logoFileBM : this.staticResources.logoFileB;
		},

		// 白
		logoFileWShow()
		{
			return this.isM ? this.staticResources.logoFileWM : this.staticResources.logoFileW;
		}
	}
}
</script>

<style lang="less">
// @import url("https://g-c-t.jy.sp/h5web/static/css/Roboto.css");
@import url("../public/static/css/Roboto.css");
:root{
	--com-number-fm:'Consolas';
	--com-number-coin-fm-L:'Roboto-L';
	--com-number-coin-fm-R:'Roboto-R';
	--com-number-coin-fm-M:'Roboto-M';
	--com-number-coin-fm-B:'Roboto-B';
	--com-base-fz-11:11px;
	--com-base-fz-12:12px;
	--com-base-fz-13:13px;
	--com-base-fz-14:14px;
	--com-base-fz-16:16px;
	--com-base-fz-17:17px;
	--com-base-fz-18:18px;
	--com-base-fz-20:20px;
	--com-base-fz-22:22px;
	--com-base-fz-24:24px;
	--com-base-fz-26:26px;
	--com-base-fz-28:28px;
	--com-base-fz-30:30px;
	--com-base-fz-32:32px;
	--com-base-fz-36:36px;
	--com-base-fz-38:38px;
	--com-base-fz-40:40px;
	--com-base-fz-48:48px;
	--com-base-fz-50:50px;
	--com-base-fz-54:54px;
	--com-base-fz-58:58px;
	--com-base-fz-60:60px;
	--com-base-container-w:1440px;
	--com-base-container-wm:750px;
	--com-base-content-wm:686px;
	--com-base-top-container-h1:600px;
	--com-base-top-container-h2:760px;
	--com-base-top-container-h2m:1160px;
	--com-base-top-container-h3:960px;
	--com-base-nav-item-h:64px;
	--com-base-nav-item-hm:64px;
	--com-base-top-box-h:500px;
	--com-base-top-mid-h:550px;
	--gradient-direction:to right;
	--gradient-color-start:#ff286f;
  	--gradient-color-end:#1aa4ab;
	--com-base-bor-rds:12px;
	--com-bg-FFF:rgba(255, 255, 255, 1);
	--com-main-ft-FFF:#FFF;
	--com-main-ft-color:#252525;
}
*{margin:0;padding:0;box-sizing:border-box;font-family:'PingFang SC', 'PingFangSC-Medium', 'Helvetica Neue', Helvetic, 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;color:#2c3e50;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing: grayscale;}
html, body{margin:0;padding:0;height:100%;}
body{padding-right:0 !important;}
.el-popup-parent--hidden{overflow:unset !important;}
a, img{outline:none;text-decoration:none;}
ul, li{list-style-type:none;}
input, button{-webkit-appearance:none;appearance:none;}
.m10{margin-top:10px;}
.m20{margin-top:20px;}
.mr10{margin-right:10px;}
.mb10{margin-bottom:10px;}
.ml10{margin-left:10px;}
.pt10{padding-top:10px;}
.pr10{padding-right:10px;}
.pb10{padding-bottom:10px;}
.pl10{padding-left:10px;}

.app_container{width:100%;height:auto;margin:0 auto;}
.nav_container{
	nav{
		width:var(--com-base-container-w);
		display:flex;justify-content:center;align-items:flex-start;
		.nav_left{
			width:102px;height:64px;
			display:flex;justify-content:flex-start;align-items:center;
			img{
				width:inherit;height:44px;
				cursor:pointer;
			}
		}
	}
}
@media (max-width: 768px){
	.app_container{width:var(--com-base-container-wm);}
	.nav_container{
		nav{
			width:var(--com-base-container-wm);
			justify-content:space-between;align-items:flex-start;
			.nav_left{
				width:200px;height:100px;
				img{
					width:142px;height:60px;
					cursor:pointer;
				}
			}
		}
	}
}

.nav_container{
	position:fixed;top:0;left:0;
	z-index:10;
	width:100%;
	background:transparent;
	display:flex;justify-content:center;align-items:flex-start;
	nav{
		.nav_left{
			display:flex;justify-content:center;align-items:center;
		}
		.nav_right{
			flex:1;
			display:flex;justify-content:flex-start;align-items:center;
			height:var(--com-base-nav-item-h);
			margin-left:90px;
			a{
				display:flex;flex-direction:column;justify-content:space-between;align-items:center;
				height:40px;
				text-align:center;
				margin-right:40px;/* padding:10px 5px 10px 5px;min-width:100px; */
				.nav_right_t{
					display:flex;justify-content:center;align-items:flex-end;
					width:100px;height:30px;
					font-family:var(--com-number-coin-fm-L);font-size:var(--com-base-fz-14);color:#FFF;text-align:center;
				}
				.nav_right_line{
					display:none;
					width:50px;height:3px;
					border-radius:50px;
					background:linear-gradient(var(--gradient-direction), var(--gradient-color-start), var(--gradient-color-end));
				}
				&:hover{
					background:transparent;
					/* border-bottom:3px solid rgba(255,255,255,1);
					border-radius:1px; */
					.nav_right_line{
						display:block;
					}
				}
			}
			.el-menu{
				background:transparent;
			}
			.el-menu--horizontal{
				border-bottom:unset;
			}
			.el-menu--horizontal>.el-menu-item{
				float: left;margin:0;margin-right:100px;padding:0;
				height:var(--com-base-nav-item-h);line-height:var(--com-base-nav-item-h);
				border-bottom:unset;/* 2px solid transparent; */
				font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-18);font-weight:bold;color:#FFF;
			}
			.el-menu--horizontal>.el-submenu{
				margin:0;margin-right:100px;
			}
			.el-menu--horizontal>.el-submenu .el-submenu__title{
				height:var(--com-base-nav-item-h);line-height:var(--com-base-nav-item-h);
				padding:0;
				border-bottom:unset;/* 2px solid transparent; */
				font-weight:bold;color:#FFF;
			}
			.el-menu--horizontal>.el-submenu .el-submenu__title i{
				font-weight:bold;margin-top:0;
			}
			.el-menu--horizontal>.el-submenu .el-submenu__title i.el-submenu__icon-arrow{
				margin-left:8px;
				font-size:var(--com-base-fz-12);
			}
			/* .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,  */
			.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, 
			.el-menu--horizontal>.el-submenu .el-submenu__title:hover{
				background-color:transparent;
				color:#000;
			}
			.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus{
				background:transparent;
			}
			.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover .nav_container{
				background:var(--com-bg-FFF);
			}
			.el-menu--horizontal>.el-menu-item.is-active{
				border-bottom:unset;/* 2px solid #409EFF; */
				color:#000;
			}
			.el-submenu__title{
				font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-18);
			}
			.el-submenu__title i{
				color:#FFF;
			}
		}
		.m-menu-right-box{
			width:100px;height:100px;
			display:flex;justify-content:center;align-items:center;
			.m-menu-right-menu{
				width:36px;height:36px;
				img{
					width:inherit;height:36px;
				}
			}
		}
		.nav_right_lang{
			display:flex;justify-content:center;align-items:center;
			height:var(--com-base-nav-item-h);
			span{
				opacity:.5;
				display:flex;justify-content:center;align-items:center;
				width:25px;height:36px;
				font-family:var(--com-number-coin-fm-B) !important;font-size:var(--com-base-fz-12);font-weight:bold;color:#000;text-align:center;
				cursor:pointer;
				&:nth-child(1){
					padding:10px 5px 10px;
				}
				&:nth-child(3){
					padding:10px 5px 10px;
				}
				&:nth-child(2){
					width:10px;
					padding:8px 5px 10px;
				}
			}
			span.active{
				opacity:1;
			}
		}
	}
}
.nav_container_spl{
	background:var(--com-bg-FFF);
	nav{
		.nav_right{
			.el-menu--horizontal>.el-menu-item{
				color:#000;
			}
			.el-menu--horizontal>.el-submenu .el-submenu__title,
			.el-submenu>.el-submenu__title .el-submenu__icon-arrow{
				color:#000;
			}
			.el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{
				color:#000;
			}
		}
	}
}
.submenu-zdy{
	background:#FFF;
	top:64px !important;
	left:0 !important;right:0 !important;margin:auto;padding:0;
	.el-menu--popup{
		border-radius:0;
		min-width:100%;
		width:100%;
		padding:0;
	}
	.el-menu-item{
		border-radius:0;
		margin-bottom:5px;padding:0 !important;
		height:320px !important;line-height:1 !important;
		font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-14);
		*{
			vertical-align:unset !important;
		}
		.el-submenu__title{
			padding:0 !important;
			height:320px;
		}
		&:last-child{
			margin-bottom:0;
		}
		.open-area{
			width:100%;
			display:flex;justify-content:flex-start;align-items:flex-start;
			.area-left{
				width:428px;height:320px;
				background:#FAFBFD;
				display:flex;flex-direction:column;justify-content:center;align-items:flex-end;
				gap:20px;
				.area-left-item{
					display:flex;justify-content:flex-start;align-items:center;
					padding-left:0px;margin-bottom:0px;
					width:190px;
					div:nth-child(1){
						width:42px;height:42px;
						img{width:inherit;height:inherit;}
					}
					div:nth-child(2){
						font-size:var(--com-base-fz-18);color:#000;font-weight:bold;
					}
					&:hover{
						div:nth-child(2){
							font-weight:bold;
							color:#1D55FF;
						}
					}
					div.active{
						font-weight:bold;
					}
				}
			}
			.area-right{
				width:1300px;height:320px;
				background:#FFF;
				display:flex;justify-content:center;align-items:flex-start;
				.right-content{
					width:inherit;height:inherit;
					display:flex;flex-direction:column;justify-content:flex-start;align-items:center;
					padding-top:50px;
					.img-box{
						width:inherit;height:130px;
						display:flex;flex-direction:row;justify-content:center;align-items:flex-start;
						gap:45px;
						.img-block{
							position:relative;
							display:flex;flex-direction:column;justify-content:flex-start;align-items:center;
							width:130px;height:130px;
							border-radius:25px;
							box-shadow:0 0 20px 0 #bfd2fa;
							img{
								width:inherit;height:inherit;
								border-radius:inherit;
							}
							div{
								position:absolute;left:0;right:0;bottom:0px;margin:auto;
								padding:3px 10px;
								height:40px;line-height:1.2;
								font-size:var(--com-base-fz-14);color:#FFF;font-weight:bold;text-align:center;
								display:flex;justify-content:center;align-items:center;
								white-space:pre-wrap;
								background:linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.1));
								border-radius:0 0 25px 25px;
							}
						}
					}
					.btn-box{
						display:flex;justify-content:center;align-items:center;
						margin-top:50px;
						button{
							width:160px;height:50px;
							border-radius:25px;border:none;outline:none;
							background:#1D55FF;
							font-size:var(--com-base-fz-18);color:#FFF;text-align:center;font-weight:bold;
							cursor:pointer;
							img{
								width:18px;height:16px;
							}
						}
					}
				}
			}
		}
	}
	.el-menu--popup-bottom-start{
		margin:0 auto;margin-top:0px;
	}
}
.fx-col{display:flex;flex-direction:column;justify-content:center;align-items:center;}
.popover-zdy{
	box-sizing:border-box !important;
	border:none !important;border-radius:var(--com-base-bor-rds) !important;
	width:auto !important;height:auto !important;
	padding:17px !important;
	left:unset !important;right:95px;
}
img[lazy="loading"]{
	display:block;
	margin:0 auto;
	width:30px !important;height:30px !important;
}
div[lazy="loading"]{
	background-size:30px 30px !important;
}
.zdyElMsg{
	i{
		font-size:var(--com-base-fz-16);
	}
	.el-message__content{
		font-size:var(--com-base-fz-16);
	}
}
.zdyElMsgMobile{
	border-radius:10px !important;
	i{
		font-size:var(--com-base-fz-24);
	}
	.el-message__content{
		font-size:var(--com-base-fz-24);
	}
}
/* ServiceAgreement, PrivacyPolicy */
.sa_container{
    width:100%;height:auto;
    position:relative;
	.title{
		position:absolute;top:100px;left:0;right:0;margin:auto;
		width:var(--com-base-container-w);height:50px;line-height:50px;
		font-family:var(--com-number-coin-fm-B) !important;font-size:var(--com-base-fz-32);color:#333;text-align:center;
	}
    .content{
        position:absolute;top:200px;left:0;right:0;margin:auto;
        width:var(--com-base-container-w);height:auto;line-height:2;
        font-size:var(--com-base-fz-14);color:#333;
        white-space:pre-wrap; /* 自动换行 */
        word-break:break-word;
    }
}
</style>
